import {
  ApiaUtil,
  ApiaUtilModalHandler,
  SimpleButton,
  TOpenModal,
} from '@apia/components';
import { AdditionalFiltersComponent } from './components/AdditionalFiltersComponent';
import { QueryController } from '../../QueryController';
import { observer } from 'mobx-react-lite';
import { Box } from '@apia/theme';
import { getLabel } from '@apia/util';

const ButtonsBar = observer(
  ({ queryController }: { queryController: QueryController }) => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
        <SimpleButton
          variant="primary-sm"
          onClick={() => {
            queryController.refresh();
          }}
          disabled={queryController.isLoading}
        >
          {getLabel('btnSearch').text}
        </SimpleButton>
        <SimpleButton
          variant="outline-sm"
          onClick={() => {
            queryController.clearFilters();
          }}
          disabled={queryController.isLoading}
        >
          {getLabel('btnClearFilter').text}
        </SimpleButton>
      </Box>
    );
  },
);

export class AdditionalFiltersModal {
  private modalHandler: ApiaUtilModalHandler | null = null;
  constructor(private queryController: QueryController) {}

  protected getModalDefinition(): TOpenModal {
    return {
      children: (
        <AdditionalFiltersComponent queryController={this.queryController} />
      ),
      onConfirm: () => {},
      confirmProps: {
        hideConfirmButton: true,
        hideCancelButton: true,
        additionalButtonsOnRight: (
          <ButtonsBar queryController={this.queryController} />
        ),
      },
      draggable: true,
      className: 'additionalFiltersModal',
      variant: 'layout.common.modals.apiaFinder.additionalFiltersModal',
      size: 'lg',
    };
  }
  public async openModal(properties?: TOpenModal) {
    this.modalHandler = ApiaUtil.instance.modals.open({
      ...this.getModalDefinition(),
      ...properties,
    });
  }
  public closeModal() {
    this.modalHandler?.close();
  }
}
